module.exports = __webpack_public_path__ + "img/transaction.cb99b3bb.svg";